import { render } from "./TabPosition.vue?vue&type=template&id=0886afb7"
import script from "./TabPosition.vue?vue&type=script&lang=js"
export * from "./TabPosition.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__